<template>
  <div class="cohort">
    <Cohort/>
  </div>
</template>

<script>
  import Cohort from '../components/Cohort.vue';
  
  export default {
    name: 'cohort',
    components: {
      Cohort,
    },
  }
</script>

<style scoped>
  .cohort {
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
</style>
